import { render, staticRenderFns } from "./SecuritySetting.vue?vue&type=template&id=fd954ad6&scoped=true&"
import script from "./SecuritySetting.vue?vue&type=script&lang=js&"
export * from "./SecuritySetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd954ad6",
  null
  
)

export default component.exports